import React, { Component } from 'react';
import BlockPerson from '../../StaticRenderer/BlockPerson';

export default class Person extends Component {
  render() {
    const {
      block,
      contentState
    } = this.props;

    const { image, name, company, email, phone } = contentState.getEntity(block.getEntityAt(0)).getData();

    return (
      <BlockPerson content={{ image, name, company, email, phone }} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/DraftEditor/PersonPlugin/Person.js